import React, { useEffect, useState } from "react";
import {
  Loading,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  Tag,
  InlineNotification,
} from "carbon-components-react";
import { DataViewAlt24 } from "@carbon/icons-react";
import { Link } from "react-router-dom";
import Card from "../../components/Card/Card";
import http from "../../http-common";
import { toast } from "react-toastify";

const tableHeaders = [
  { header: "Empresa", key: "companyName" },
  { header: "UUID da Candidatura", key: "applicationUuid" },
  { header: "Estado", key: "prototypeStatus" },
  { header: " ", key: "actions" },
];

const StatusTag = ({ status }) => {
  if (status === "SUBMITTED") {
    return <Tag type="green">Submetido</Tag>;
  }
  return <Tag type="gray">Rascunho</Tag>;
};

const getCellContent = (cell, rowId) => {
  if (cell.info.header === "actions") {
    return (
      <Link to={`../prototype/${rowId}`} title="Ver Protótipo">
        <DataViewAlt24 />
      </Link>
    );
  }
  if (cell.info.header === "prototypeStatus") {
    return <StatusTag status={cell.value} />;
  }
  return cell.value;
};

const ListPrototypesPage = () => {
  const [prototypes, setPrototypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchPrototypes = async () => {
      try {
        const response = await http.get("/prototypes");
        const data = response.data.map((p) => ({
          id: p.uuid,
          companyName: p.companyName,
          applicationUuid: p.applicationUuid,
          prototypeStatus: p.prototypeStatus,
        }));
        if (isMounted) {
          setPrototypes(data);
          setTimeout(() => {
            if (isMounted) setIsLoading(false);
          }, 100);
        }
      } catch (error) {
        toast.error("Erro ao carregar protótipos");
        if (isMounted) setIsLoading(false);
      }
    };

    fetchPrototypes();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Card title="Protótipos Submetidos">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      {!isLoading && prototypes.length === 0 && (
        <InlineNotification
          kind="info"
          title="Sem resultados"
          subtitle="Não existem protótipos submetidos. Os protótipos apenas aparecem nesta lista após serem submetidos pelo concorrente."
          hideCloseButton
          style={{ marginBottom: "1rem", maxWidth: "100%" }}
        />
      )}

      <DataTable rows={prototypes} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="prototypes table toolbar">
              <TableToolbarContent />
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })} key={header.key}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default ListPrototypesPage;
